var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3B3B3B",
    strokeWidth: 2,
    d: "M5.333 12.667c0-.495-.488-1.234-.983-1.854a8.7 8.7 0 0 0-2.267-2.03C1.429 8.383.637 8 0 8m0 0c.637 0 1.43-.383 2.083-.783a8.8 8.8 0 0 0 2.267-2.03c.495-.62.983-1.36.983-1.854M0 8h16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.da91b37581882bbb9907abdd8a7e21af.svg";
export { ForwardRef as ReactComponent };